import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label?: string;
  note?: string;
  id?: string;
  className?: string;
};
export function CTAButton({
  label = 'GET INSTANT ACCESS NOW',
  note = 'Instant download · No subscription · Lifetime access · 7-day guarantee',
  id,
  className = ''
}: CTAButtonProps) {
  return <div id={id} className={`w-full ${className}`} data-id="element-25" data-mp="2tykx6gxd2hrg">
      <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-2xl bg-gold px-5 py-4 text-center text-base font-extrabold uppercase tracking-wide text-white shadow-[0_10px_30px_-10px_rgba(184,145,47,0.9)] transition-all duration-200 hover:bg-gold-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-dark active:scale-[0.98] sm:text-lg" data-id="element-26" data-mp="2tx9s8ds6j3yr">
        <span data-id="element-27" data-mp="38pab3r27iaz0">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-28" data-mp="38ptrh3c7krax" />
      </a>
      {note ? <p className="mt-3 text-center text-[11px] leading-relaxed text-ink-soft sm:text-xs" data-id="element-29" data-mp="1db9qdxsfng1d">
          {note}
        </p> : null}
    </div>;
}